import axios from '@axios';
// import HelperService from '@/services/HelperService';

// const helperService = new HelperService();
const base = '/api/v1/visitor-users';

export default {
  getUser(userId) {
    return axios.get(`${base}/user/${userId}`);
  },
};
